export const getDishImageUrl = image => {
  if (!Array.isArray(image) || !image.length) return ''
  const merged = Object.assign({}, ...image)
  return merged.UrlS || merged.Url || merged.UrlB || ''
}
